// extracted by mini-css-extract-plugin
export default {"wrap":"ChallengeRun_wrap__VsYlC"};